@if (showError()) {
  <pxc-error-icon [message]="errorMessages()" />
}
